import Address from '__core/shared/model/address/Address';
import { ZoningOption } from '__core/shared/model/global/ZoningOption.enum';
import { PropertyType } from '__core/shared/model/global/PropertyType.enum';
import { OwnershipType } from '__core/shared/model/global/OwnershipType.enum';
import PropertyDetails from '__core/shared/model/finance/PropertyDetails';
import {
  PropertyDetailsType,
  propertyDetailsTypes
} from '__core/shared/model/finance/PropertyDetails.enum';
import template from './propertySearch.template.html';

export default {
  template,
  bindings: {
    countries: '<',
    validationErrors: '<',
    contactsForValuation: '<',
    titleDetails: '<',
    property: '<',
    compliance: '<',
    ticketOwner: '<',
    idTicket: '<',
    isDisabled: '<',
    onChange: '&',
    onPropertyFinished: '&',
    onFinished: '&'
  },
  controllerAs: '$ctrl',
  controller: class controller {
    constructor(
      $rootScope,
      $mdDialog,
      helperService,
      eventService,
      dateTimeService,
      coreLogicService,
      priceFinderService
    ) {
      'ngInject';

      const ctrl = this;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.availableStates = helperService.getAvailableAddressStates();
        ctrl.availableStreetTypes = helperService.getAvailableAddressStreetTypes();
        ctrl.availablePropertyDetailsTypes = propertyDetailsTypes;
        ctrl.countries = ctrl.countries || [];
        ctrl.validationErrors = ctrl.validationErrors || [];
        ctrl.contactsForValuation = ctrl.contactsForValuation || [];
        ctrl.titleDetails = ctrl.titleDetails || [];
        ctrl.property = ctrl.property || {};
        ctrl.compliance = ctrl.compliance || {};
        ctrl.ticketOwner = ctrl.ticketOwner || {};
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.isDisabled = ctrl.isDisabled || false;
        ctrl.currentPropertyAddress = ctrl.property?.address?.formatted || '';
        ctrl.searchType = '';
        if (ctrl.ticketOwner?.isRpDataEnabled() && !ctrl.ticketOwner.isPriceFinderEnabled()) {
          ctrl.searchType = PropertyDetailsType.rp_data.name;
        }
        if (ctrl.ticketOwner.isPriceFinderEnabled() && !ctrl.ticketOwner?.isRpDataEnabled()) {
          ctrl.searchType = PropertyDetailsType.pricefinder.name;
        }
      };

      ctrl.changeCountry = () => {
        const country = _.find(
          ctrl.countries,
          (c) =>
            c?.name?.common?.toLowerCase() === ctrl.property?.address?.country?.toLowerCase()
        );
        if (country?.name?.common) {
          ctrl.property.address.city = '';
          ctrl.property.address.country = country?.name?.common || '';
          ctrl.property.address.countryCode = country?.cca2 || '';
          ctrl.property.address.district = '';
          ctrl.property.address.formatted = '';
          ctrl.property.address.id = '';
          ctrl.property.address.idLinkedAddress = '';
          ctrl.property.address.latitude = '';
          ctrl.property.address.longitude = '';
          ctrl.property.address.placeId = '';
          ctrl.property.address.postCode = '';
          ctrl.property.address.state = '';
          ctrl.property.address.street = '';
          ctrl.property.address.streetNumber = '';
          ctrl.property.address.streetType = '';
          ctrl.property.address.suburb = '';
          ctrl.property.address.suiteNumber = '';
          ctrl.property.address.postOfficeBox = '';
          ctrl.property.address.isPostOfficeBoxEnabled = false;
          ctrl.saveProperty();
        }
      };

      ctrl.getCountryCca2 = () =>
        !ctrl.property?.address?.country && !ctrl.property?.address?.countryCode
          ? ctrl.organizationCountry?.cca2
          : ctrl.property.address.countryCode;

      ctrl.searchPropertyAddresses = (query) => {
        if (ctrl.searchType === PropertyDetailsType.rp_data.name) {
          return ctrl.searchRPDataPropertyAddresses(query, ctrl.getCountryCca2());
        }
        if (ctrl.searchType === PropertyDetailsType.pricefinder.name) {
          return ctrl.searchPriceFinderPropertyAddresses(query);
        }
        return [];
      };

      ctrl.searchRPDataPropertyAddresses = (query, cca2) =>
        coreLogicService
          .rpDataPropertySearch({
            idOwner: ctrl.ticketOwner?.id,
            query,
            cca2
          })
          .then((res) => {
            let list = [];
            if (res?.status) {
              list = res?.list || [];
            }
            return list;
          });

      ctrl.searchPriceFinderPropertyAddresses = (query) =>
        priceFinderService
          .propertySearch({
            idOwner: ctrl.ticketOwner?.id,
            query,
            cca2: ctrl.organizationCountry?.cca2
          })
          .then((res) => res?.list || []);

      ctrl.selectedPropertyAddressChange = (item) => {
        if (item?.propertyId) {
          ctrl.onChange({ data: { id: ctrl.property?.id, isReady: false } });
          const handler =
            ctrl.searchType === PropertyDetailsType.rp_data.name
              ? coreLogicService.rpDataPropertyDetails({
                  idOwner: ctrl.ticketOwner?.id,
                  idTicket: ctrl.idTicket,
                  property: ctrl.property,
                  propertyId: item?.propertyId,
                  cca2: ctrl.getCountryCca2()
                })
              : priceFinderService.propertyDetails({
                  idOwner: ctrl.ticketOwner?.id,
                  idTicket: ctrl.idTicket,
                  property: ctrl.property,
                  propertyId: item?.propertyId
                });

          handler.then((res) => {
            if (res?.status) {
              ctrl.property.address = new Address(res?.data?.propertyDetails?.address);
              ctrl.property.value = res?.data?.propertyDetails?.averagePrice || 0;
              ctrl.property.zoning = ZoningOption.of(res?.data?.propertyDetails?.zone?.name);
              ctrl.property.ownershipType = OwnershipType.of(
                res?.data?.propertyDetails?.ownershipType?.name
              );
              ctrl.property.propertyType = PropertyType.of(
                res?.data?.propertyDetails?.propertyType?.name
              );
              ctrl.property.propertyDetails = new PropertyDetails({
                idOwner: ctrl.ticketOwner?.id,
                propertyId: res?.data?.propertyDetails?.propertyId,
                locationId: res?.data?.propertyDetails?.locationId,
                type:
                  ctrl.searchType === PropertyDetailsType.rp_data.name
                    ? PropertyDetailsType.rp_data
                    : PropertyDetailsType.pricefinder,
                timeStamp: dateTimeService.epoch()
              });

              const contactsForValuationIdx = _.findIndex(
                ctrl.contactsForValuation || [],
                (s) => s?.idSecurity === ctrl.property?.id
              );
              if (
                contactsForValuationIdx > -1 &&
                ctrl.contactsForValuation[contactsForValuationIdx]?.isOther
              ) {
                ctrl.contactsForValuation[contactsForValuationIdx].companyName =
                  res?.data?.propertyDetails?.contactsForValuation?.companyName ||
                  ctrl.contactsForValuation[contactsForValuationIdx]?.companyName ||
                  '';
                ctrl.contactsForValuation[contactsForValuationIdx].firstName =
                  res?.data?.propertyDetails?.contactsForValuation?.firstName ||
                  ctrl.contactsForValuation[contactsForValuationIdx]?.firstName ||
                  '';
                ctrl.contactsForValuation[contactsForValuationIdx].surname =
                  res?.data?.propertyDetails?.contactsForValuation?.surname ||
                  ctrl.contactsForValuation[contactsForValuationIdx]?.surname ||
                  '';
                ctrl.contactsForValuation[contactsForValuationIdx].phoneCode =
                  res?.data?.propertyDetails?.contactsForValuation?.phoneCode ||
                  ctrl.contactsForValuation[contactsForValuationIdx]?.phoneCode ||
                  '';
                ctrl.contactsForValuation[contactsForValuationIdx].phone =
                  res?.data?.propertyDetails?.contactsForValuation?.phone ||
                  ctrl.contactsForValuation[contactsForValuationIdx]?.phone ||
                  '';
                ctrl.contactsForValuation[contactsForValuationIdx].phone = new Address(
                  res?.data?.propertyDetails?.contactsForValuation?.address
                );
              }

              const titleDetailsIdx = _.findIndex(
                ctrl.titleDetails || [],
                (s) => s?.idSecurity === ctrl.property?.id
              );
              if (titleDetailsIdx > -1) {
                ctrl.titleDetails[titleDetailsIdx].volume =
                  res?.data?.propertyDetails?.titleDetails?.volume ||
                  ctrl.titleDetails[titleDetailsIdx]?.volume ||
                  0;
                ctrl.titleDetails[titleDetailsIdx].lot =
                  res?.data?.propertyDetails?.titleDetails?.lot ||
                  ctrl.titleDetails[titleDetailsIdx]?.lot ||
                  0;
                ctrl.titleDetails[titleDetailsIdx].folio =
                  res?.data?.propertyDetails?.titleDetails?.folio ||
                  ctrl.titleDetails[titleDetailsIdx]?.folio ||
                  0;
                ctrl.titleDetails[titleDetailsIdx].plan =
                  res?.data?.propertyDetails?.titleDetails?.plan ||
                  ctrl.titleDetails[titleDetailsIdx]?.plan ||
                  '';
              }

              if (!_.isEmpty(ctrl?.compliance?.comments)) {
                const securityComments = ctrl?.compliance?.comments?.security?.trim();
                ctrl.compliance.comments.security = `${securityComments}${
                  securityComments ? '\n' : ''
                }${res?.data?.propertyDetails?.securityComments || ''}`;
              }

              if (!_.isEmpty(ctrl?.compliance?.verifications)) {
                ctrl.compliance.verifications.propertySearchesCompleted = 1;
                ctrl.compliance.verifications.propertySearchesCompletedVerificationMethod =
                  ctrl.searchType === PropertyDetailsType.rp_data.name
                    ? `${
                        ctrl.organizationCountry?.cca2 === 'AU'
                          ? 'CoreLogic RP Data'
                          : 'CoreLogic Property Guru'
                      }`
                    : 'Pricefinder';
                ctrl.compliance.verifications.propertySearchesCompletedDateVerified =
                  dateTimeService.epoch();
              }

              ctrl.onChange({ data: { id: ctrl.property?.id, isReady: true } });
              ctrl.onPropertyFinished({
                data: { id: ctrl.property?.id, propertyDetails: res?.data || {} }
              });
            } else {
              const alert = helperService.errorsAlert({
                errors: res?.errors || [],
                errorMessage: res?.errorMessage || '',
                title: `${
                  ctrl.searchType === PropertyDetailsType.rp_data.name
                    ? 'RPData'
                    : 'Pricefinder'
                }`
              });
              eventService.alertDialog({ alert });
            }
          });
        }
      };

      ctrl.onPropertyAddressBlur = () => {
        if (ctrl.property?.propertyDetails?.propertyId && ctrl.currentPropertyAddress) {
          ctrl.searchTerm = ctrl.currentPropertyAddress;
        }
      };

      ctrl.isValidPostCode = (postCode, country) => {
        if (country === 'Australia' || country === 'New Zealand') {
          return /\b(\d{4})\b/.test(postCode) && String(postCode).length === 4;
        }
        return true;
      };

      ctrl.getIcon = (item) => {
        let icon = 'home';
        if (ctrl.searchType === PropertyDetailsType.rp_data.name) {
          if (item?.propertyId) {
            icon = item?.isUnit ? 'location_city' : 'home';
          } else {
            icon = 'leak_add';
          }
        }
        return icon;
      };

      ctrl.selectedPropertyAddressStreetTypeChange = (item) => {
        if (item?.value) {
          ctrl.saveProperty();
        }
      };

      ctrl.onBlur = () => {
        ctrl.property.address.streetType = ctrl.searchStreetTypeTerm;
        ctrl.saveProperty();
      };

      ctrl.searchStreetTypes = () =>
        _.filter(
          ctrl.availableStreetTypes,
          (type) =>
            type?.value?.toLowerCase()?.indexOf(ctrl.searchStreetTypeTerm?.toLowerCase()) !== -1
        );

      ctrl.hasValidationError = ({ path }) =>
        helperService.hasValidationError({ errors: ctrl.validationErrors, path });

      ctrl.saveProperty = _.debounce(() => {
        if (!_.isEmpty(ctrl.property.propertyDetails)) {
          ctrl.property.propertyDetails = new PropertyDetails({
            idOwner: '',
            propertyId: '',
            locationId: '',
            type: PropertyDetailsType.none,
            timeStamp: 0
          });
        }
        ctrl.onFinished();
      }, 1500);

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
